import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PlanCategory } from '@/shared/types/Billing';

type TGetButtonEvent = {
  category: PlanCategory;
  isDowngradePlan: boolean;
  isSwitchToAnnualPlan: boolean;
  isUpgradePlan: boolean;
  planName: string;
  subscription?: string;
};

type TEventPayload = {
  [key: string]: string;
};

type TUpgradeEvent = {
  [key in PlanCategory]?: (payload?: TEventPayload) => void;
};

type TUpgradeEvents = {
  switchToAnnualPlan: TUpgradeEvent;
  upgradePlan: TUpgradeEvent;
};

const EVENTS: TUpgradeEvents = {
  switchToAnnualPlan: {
    [PlanCategory.Business]: MixpanelEvents.switchAnnualBusinessClick,
    [PlanCategory.Creator]: MixpanelEvents.switchAnnualCreatorClick,
    [PlanCategory.CreatorPro]: MixpanelEvents.switchAnnualCreatorProClick,
  },
  upgradePlan: {
    [PlanCategory.Business]: MixpanelEvents.upgradeBusinessClick,
    [PlanCategory.Creator]: MixpanelEvents.upgradeCreatorClick,
    [PlanCategory.CreatorPro]: MixpanelEvents.upgradeCreatorProClick,
  },
};

export const getMixpanelButtonEvent = ({
  category,
  isDowngradePlan,
  isSwitchToAnnualPlan,
  isUpgradePlan,
  planName,
  subscription,
}: TGetButtonEvent) => {
  if (isSwitchToAnnualPlan) {
    return EVENTS.switchToAnnualPlan[category];
  }

  if (isUpgradePlan) {
    return EVENTS.upgradePlan[category]?.({ planName });
  }

  if (isDowngradePlan) {
    return undefined;
  }

  return MixpanelEvents.choosePlan({ name: planName, subscription: subscription ?? planName });
};
